module.exports = __webpack_public_path__ + "img/PT_final_signature.4c476354.gif";